"use client"

import type {ProjectSummary} from "@devplaninc/codeup";
import type {StateCreator} from "zustand/vanilla";

export interface CachedProjectSummary {
  summary: ProjectSummary | null
  updatedAt: number
}

export interface ProjectSummariesStoreState {
  projectSummaries: Record<number, Record<string, CachedProjectSummary>>
  setProjectSummary(companyId: number, projectId: string, summary: ProjectSummary | null): void
  setProjectSummaries(
    companyId: number,
    summaries: Record<string, ProjectSummary | undefined>,
  ): void
}

export const createProjectSummariesSlice: StateCreator<
  ProjectSummariesStoreState,
  [],
  [],
  ProjectSummariesStoreState
> = set => ({
  projectSummaries: {},
  setProjectSummary: (companyId, projectId, summary) => set(state => ({
    projectSummaries: {
      ...state.projectSummaries,
      [companyId]: {
        ...state.projectSummaries[companyId],
        [projectId]: {summary, updatedAt: Date.now()},
      },
    },
  })),
  setProjectSummaries: (companyId, summaries) => set(state => {
    const updatedAt = Date.now()
    const entries = Object.fromEntries(
      Object.entries(summaries).map(([projectId, summary]) => {
        const existing = state.projectSummaries[companyId]?.[projectId]
        return [projectId, summary === undefined && existing
          ? existing
          : {summary: summary ?? null, updatedAt}]
      }),
    )
    return {
      projectSummaries: {
        ...state.projectSummaries,
        [companyId]: {...state.projectSummaries[companyId], ...entries},
      },
    }
  }),
})
